<template>
  <div class="login-page">
    <div class="title-box">
      <p>金桥物业管理系统（超管后台）</p>
    </div>
    <div class="auth-box">
      <a-form :form="form" @submit="handleSubmit" class="login-form" :label-col="{span:6}" :wrapper-col="{span:14}">
        <a-form-item label="账号" style="color: #ffffff;">
          <a-input v-decorator="['account', { rules: [{ required: true, message: '请输入账号！' }] }]" placeholder="邮箱或用户名">
            <a-icon slot="prefix" type="user" style="color: rgba(0,0,0,.25)" />
          </a-input>
        </a-form-item>
        <a-form-item label="密码">
          <a-input
              v-decorator="['password',{ rules: [{ required: true, message: '请输入密码！' }] },]"
              type="password"
              placeholder="密码">
            <a-icon slot="prefix" type="lock" style="color: rgba(0,0,0,.25)" />
          </a-input>
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 12, offset: 16 }">
          <a-button type="primary" html-type="submit">登录</a-button>
        </a-form-item>
      </a-form>
    </div>
    <div class="bottom-filings">
      <p>@2020-2023 甘肃金桥软件开发有限公司版权所有</p>
      <a href="https://beian.miit.gov.cn/" target="_blank">陇ICP备19000167号</a>
    </div>
  </div>
</template>

<script>
import AuthService from "@/service/AuthService";
import HttpUtil from "@/utils/HttpUtil";
export default {
  name: "Login",
  data(){
    return {
      form: this.$form.createForm(this,{name: 'form1'})
    }
  },
  methods: {
    handleSubmit(e){
      e.preventDefault();
      this.form.validateFields((err,values)=>{
        if (!err){
          console.log('验证通过',values);
          AuthService.login(values.account,values.password).then((data)=>{
            console.log("登陆成功",data);
            sessionStorage.setItem("is_login",true)
            this.getDetails()
            // this.$store.commit("changeLogin", res.body)
           
          }).catch(e=>{
            this.$message.error(e);
          })
        }
      })
    },
    //获取员工信息
    getDetails(){
      HttpUtil.get(
        '/data-center-provider/admin/getAdminDetails'
      ).then((res) => {
        if(res.code=="ok"){
          sessionStorage.setItem("userName",res.body.realName)
           this.$router.push({path: '/'});
        }     
      });
    }
  }
}
</script>

<style lang="less">
.login-page{
  position: relative;
  display: flex;
  flex: 1;
  width: 100vw;
  height: 100vh;
  min-width: 1366px;
  min-height: 768px;
  justify-content: center;
  background: url("../assets/images/login-bg.png");
  .title-box{
    position: absolute;
    color: white;
    top: 50vh;
    margin-top: -200px;
    p{
      font-size: 24px;
    }
  }
  .auth-box{
    border-radius: 5px;
    position: absolute;
    margin-top: -150px;
    background-color: rgba(200,200,200,.2);
    top: 50vh;
    border: 1px solid rgba(0,0,0,.1);
    width: 400px;
    height: 200px;
    padding-top: 20px;
    .ant-form-item-label label{
      color: #DFDFDF;
    }
  }
  .bottom-filings{
    width: 100%;
    position: absolute;
    bottom:10px;
    text-align: center;
    color: #ccc;
    a{
      color: #ccc;
      margin-left: 10px;
    }
  }
}
</style>